'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.apigee = apigee;

var _acsScWebPlatformApi = require('@adsk/acs-sc-web-platform-api');

function apigee(options) {
    var getURLWithParams = function getURLWithParams(apigeeConfigURL, path, params) {
        var url = '' + (apigeeConfigURL || '') + path;
        var urlWithParams = new URL(url);

        if (params) {
            var query = new URLSearchParams(params);
            urlWithParams.search = query.toString();
        }

        return urlWithParams.toString();
    };

    return {
        post: async function post(path) {
            var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            var params = arguments[2];
            var postOptions = arguments[3];

            return getApigeeOptions(options).then(function (apigeeConf) {
                var url = getURLWithParams(apigeeConf.url, path, params);
                var reqOptions = _extends({}, apigeeConf.options, _extends({
                    method: 'POST',
                    body: JSON.stringify(payload),
                    url: url,
                    withCredentials: true
                }, postOptions));

                return sendRequest(reqOptions);
            });
        },
        get: function get(path) {
            var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

            return getApigeeOptions(options).then(function (apigeeConf) {
                var url = getURLWithParams(apigeeConf.url, path, params);
                var reqOptions = _extends({}, apigeeConf.options, {
                    method: 'GET',
                    url: url,
                    withCredentials: true,
                    validateStatus: function validateStatus(status) {
                        return 200 <= status && status < 400;
                    }
                });

                return sendRequest(reqOptions);
            });
        },
        patch: function patch(path) {
            var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

            return getApigeeOptions(options).then(function (apigeeConf) {
                var url = getURLWithParams(apigeeConf.url, path, params);
                var reqOptions = _extends({}, apigeeConf.options, {
                    method: 'PATCH',
                    url: url,
                    body: JSON.stringify(payload),
                    withCredentials: true
                });

                return sendRequest(reqOptions);
            });
        },
        delete: function _delete(path) {
            return getApigeeOptions(options).then(function (apigeeConf) {
                var url = getURLWithParams(apigeeConf.url, path);
                var reqOptions = _extends({}, apigeeConf.options, {
                    method: 'DELETE',
                    url: url,
                    withCredentials: true
                });

                return sendRequest(reqOptions);
            });
        }
    };
}

function getApigeeHeaders(apiOptions) {
    var headers = {
        'X-CSRF-TOKEN': apiOptions.getCsrfToken(),
        'Content-Type': 'application/json',
        'Accept': 'application/json'
    };
    var csrfToken = apiOptions.getCsrfToken();
    if (csrfToken) {
        headers['X-CSRF-TOKEN'] = csrfToken;
    }

    return headers;
}

async function getApigeeOptions(apiOptions) {
    var headers = getApigeeHeaders(apiOptions);

    return {
        url: apiOptions.baseUrl,
        options: apiOptions['mock-header'] ? apiOptions['mock-header'] : {
            credentials: 'include',
            headers: headers
        }
    };
}

async function handleBlobRequest(options) {
    var res = await (0, _acsScWebPlatformApi.fetchResponseWithToken)(options.url, options);

    if (!res.ok) {
        throw new Error({
            code: res.status,
            message: res.statusText
        });
    }

    return await res.blob();
}

async function sendRequest(options) {
    return options.responseType === 'blob' ? await handleBlobRequest(options) : await (0, _acsScWebPlatformApi.fetchWithToken)(options.url, options);
}